<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="8">
        <v-card flat>
          <v-card-title>Фирма Артикет ЕООД е бенефициент по следните Европроекти:</v-card-title>
          <v-card-text>
            <p>
              Проект: <a href="/img/Prilojenie.jpg" target="_blank">BG16RFOP002-2.073-2717-C01</a> <br>
              Проект: <a href="/img/prilojenie-articket.docx" target="_blank">Проект: BG16RFOP002-2.095-2494</a> <br>
              Проект: <a href="/img/BG16RFOP002-articket.docx" target="_blank">Проект: BG16RFOP002-2.097-2476</a>
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "euro-projects"
}
</script>

<style scoped></style>
